/**
 * goTo
 * core 接口定义
 */
// coverconfig接口解析返回data格式
// 小程序对应的appid
const appidMap = {
    'wxmp': 'wxaf35009675aa0b2a',
    'thwxmp': 'wx5d32d893dc4d0064',
    'gaswxmp': 'wx0d252f6ed9755862',
    'kfwxmp': 'wxd98a20e429ce834b',
    'qjwxmp': 'wx9e9b87595c41dbb7',
    'yxwxmp': 'wxebb11cb254ce8575',
    'sfcwxmp': 'wxdda4c7baff6748d1',
    'hywxmp': 'wxab1642da834a1339',
    'dymp': 'ttc4c2b27f5bfd0d8701' // UT抖音小程序
};
// 小程序对应的 appsourceid
const appIdSourceMap = {
    'wxaf35009675aa0b2a': 'gh_7a5c4141778f',
    'wxd7fa7df243b05aed': 'gh_b7d6e20bb6b5',
    'wx5d32d893dc4d0064': 'gh_95c73c772f7d',
    'wx0d252f6ed9755862': 'gh_aa7619f8455b',
    'wxd98a20e429ce834b': 'gh_6617da09780d',
    'wx9e9b87595c41dbb7': 'gh_0f3405792a89',
    'wxebb11cb254ce8575': 'gh_233a09669f6e',
    'wxdda4c7baff6748d1': 'gh_5130cb373003',
    'wxab1642da834a1339': 'gh_b094e4f2edeb',
    'ttc4c2b27f5bfd0d8701': '' // UT抖音小程序
};
export { appidMap, appIdSourceMap };
